import { isAnyOf, socketConnected, startListening } from '@betty/toolkit/state';
import {
  getCashBalance,
  depositApproved,
  withdrawalApproved,
} from '@betty/wallet/state';
import { Notification, RewardType } from '@betty/rewards/state';
import { purchaseShopItem } from '@betty/shop/state';

startListening({
  actionCreator: socketConnected,
  effect: (action, { dispatch }) => {
    const socketConnection = action.payload;

    socketConnection.on(
      'RewardMessageReceived',
      (notification: Notification) => {
        if (
          notification.rewards.some(
            (reward) =>
              reward.rewardType === RewardType.Cash ||
              reward.rewardType === RewardType.Bonus,
          )
        ) {
          dispatch(getCashBalance());
        }
      },
    );
  },
});

startListening({
  matcher: isAnyOf(
    depositApproved,
    withdrawalApproved,
    purchaseShopItem.fulfilled,
  ),
  effect: (_, { dispatch }) => {
    dispatch(getCashBalance());
  },
});
